import React, { useCallback, useRef, useState } from "react";
import { PrePostItem } from "src/page-components/cruise/itinerary/types";
import * as styles from "./CruiseItineraryPrePostItem.module.scss";
import { Icon } from "@silversea-ssc/ui-components-react";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import CruiseItineraryItemDetails from "../CruiseItineraryItemDetails";
import {
  ItineraryItemExpand,
  ItineraryItemTitle
} from "../CruiseItineraryItem";
import IncludedWithFaresBadge from "components/IncludedWithFaresBadge/IncludedWithFaresBadge";
import { useUnbundlingFeatureFlagEnabled } from "features/fare/unbundling-fares";

type Props = {
  item: PrePostItem;
  tokenValues?: TokenValues;
};

const CruiseItineraryPrePostItem: React.FC<Props> = ({ item, tokenValues }) => {
  const [opened, setOpened] = useState(false);

  const detailsRef = useRef<HTMLDivElement | null>(null);
  const toggleDetails = useCallback(
    (
      e:
        | React.MouseEvent<HTMLDivElement, MouseEvent>
        | React.KeyboardEvent<HTMLDivElement>
    ) => {
      e.preventDefault();
      if (
        !detailsRef?.current ||
        !detailsRef.current.contains(e.target as Node)
      ) {
        setOpened(!opened);
      }
      //setOpened(!opened);
    },
    [opened]
  );

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.code == "Space" || e.code == "Enter") toggleDetails(e);
    },
    [toggleDetails]
  );

  const isUnbundling = useUnbundlingFeatureFlagEnabled();

  return (
    <div
      className={styles.item}
      onClick={toggleDetails}
      onKeyDown={onKeyDown}
      role="button"
      aria-pressed={opened}
      tabIndex={0}
      style={{ cursor: "pointer" }}
      data-content-piece="details_button"
    >
      {!isUnbundling && (
        <div className={styles.faresBadge}>
          <IncludedWithFaresBadge fareCodes={item.fares} />
        </div>
      )}
      <div className={styles.header}>
        <div className={styles.icon}>
          <Icon
            name={item.content.icon}
            padding={false}
            size="2.5x"
            ariaHidden={true}
          />
        </div>
        <ItineraryItemTitle title={item.content.infographicTitle} />
      </div>

      <ItineraryItemExpand opened={opened} className={styles.expand} />
      {opened && (
        <div className={styles.details} ref={detailsRef}>
          <React.Suspense fallback={<div></div>}>
            <CruiseItineraryItemDetails
              title={item.content.title}
              description={item.content.description}
              tokenValues={tokenValues}
            />
          </React.Suspense>
        </div>
      )}
    </div>
  );
};

export default CruiseItineraryPrePostItem;
